export default "__VITE_ASSET__BBiLzqAS__"